
import loginIcon from "../../imagenesLogin/login-icon.svg"
import passwordIcon from "../../imagenesLogin/password-icon.svg"
import usernameIcon from "../../imagenesLogin/username-icon.svg"
import mailIcon from "../../imagenesLogin/mail.png"
import Error from "../Error"
import { useState } from "react"


const Registrar = ()=>{
    const [nombreRegistro, setNombreRegistro] = useState("")
    const [apellidoRegistro, setApellidoRegistro] = useState("")
    const [mailRegistro, setMailRegistro] = useState("")
    const [passwordRegistro, setPasswordRegistro] = useState("")
    const [repedirPasswordRegistro, setRepedirPasswordRegistro] = useState("")
    const [error , setError] = useState(false)

    const handleSubmit= e=>{
      if([nombreRegistro,apellidoRegistro,mailRegistro, passwordRegistro, repedirPasswordRegistro].includes('')){
          console.log("Todos los campós son obligatorios")
          setError(true)
          return
      }
      setError(false)
    }
    return(
        <div className=" d-flex justify-content-center align-items-center mt-5">
        <div
          className="bg-white p-5 rounded-5 text-secondary shadow "
          style={{width: "25rem"}}
        >
          <div className="d-flex justify-content-center">
            <img
              src={loginIcon}
              alt="login-icon"
              style={{height: "7rem"}}
            />
          </div>
          <div className="text-center fs-1 fw-bold">Crea tu cuenta</div>
           {error && 
            <Error><p>Todos los campos son requeridos</p></Error>
           }
          <div className="input-group mt-4">
            <div className="input-group-text bg-warning">
              <img
                src={usernameIcon}
                alt="username-icon"
                style={{height: "1rem"}}
              />
            </div>
            <input
              className="form-control bg-light"
              type="text"
              placeholder="Nombre"
              value={nombreRegistro}
              onChange={e=>setNombreRegistro(e.target.value)}
            />
          </div>
          <div className="input-group mt-1">
            <div className="input-group-text bg-warning">
              <img
                src={usernameIcon}
                alt="usernameIcon"
                style={{height: "1rem"}}
              />
            </div>
            <input
              className="form-control bg-light"
              type="text"
              placeholder="Apellido"
              value={apellidoRegistro}
              onChange={e=>setApellidoRegistro(e.target.value)}
            />
          </div>
          <div className="input-group mt-1">
            <div className="input-group-text bg-warning">
              <img
                src={mailIcon}
                alt="mailIcon"
                style={{height: "1rem"}}
              />
            </div>
            <input
              className="form-control bg-light"
              type="email"
              placeholder="Mail"
              value={mailRegistro}
              onChange={e=>setMailRegistro(e.target.value)}
            />
          </div>
          <div className="input-group mt-1">
            <div className="input-group-text bg-warning">
              <img
                src={passwordIcon}
                alt="password-icon"
                style={{height: "1rem"}}
              />
            </div>
            <input
              className="form-control bg-light"
              type="password"
              placeholder="Contraseña"
              value={passwordRegistro}
              onChange={e=>setPasswordRegistro(e.target.value)}
            />
          </div>
          <div className="input-group mt-1">
            <div className="input-group-text bg-warning">
              <img
                src={passwordIcon}
                alt="password-icon"
                style={{height: "1rem"}}
              />
            </div>
            <input
              className="form-control bg-light"
              type="password"
              placeholder="Repetir contraseña"
              value={repedirPasswordRegistro}
              onChange={e=>setRepedirPasswordRegistro(e.target.value)}
            />
          </div>

          <div className="btn btn-warning text-white w-100 mt-4 fw-semibold shadow-sm" onClick={handleSubmit}>
            Registrar
          </div>
        </div>
        </div>
    )
}

export default Registrar